/**
 * Conseils pour le mode Facile (IA) — pas utilisé en Normal+ ni en ligne.
 */
import { getLegalMoves, playerHasCapture } from "./engine";

function label(x, y) {
  return `(${x}, ${y})`;
}

function pickCoachMove(moves, player) {
  const captures = moves.filter((m) => m.captures.length > 0);
  if (captures.length) {
    captures.sort((a, b) => {
      if (b.captures.length !== a.captures.length) return b.captures.length - a.captures.length;
      return 0;
    });
    return captures[0];
  }
  const simple = moves.filter((m) => m.captures.length === 0);
  if (player === "A") {
    simple.sort((a, b) => b.to[1] - a.to[1] || b.to[0] - a.to[0]);
  } else {
    simple.sort((a, b) => a.to[1] - b.to[1] || a.to[0] - b.to[0]);
  }
  return simple[0] || moves[0];
}

/**
 * @returns {{ message: string, suggestFrom: [number,number], suggestTo: [number,number] } | null}
 */
export function getCoachHint(board, player) {
  const moves = getLegalMoves(board, player);
  if (!moves.length) return null;

  const mustCapture = playerHasCapture(board, player);
  const move = pickCoachMove(moves, player);
  const { from, to, captures } = move;

  let message;
  if (mustCapture && captures.length > 0) {
    const [cx, cy] = captures[0];
    const pieces = new Set();
    for (const m of moves) {
      if (m.captures.length) pieces.add(`${m.from[0]},${m.from[1]}`);
    }
    if (pieces.size > 1) {
      message = `Capture obligatoire ! Le pion en ${label(from[0], from[1])} peut prendre celui en ${label(cx, cy)} — allez en ${label(to[0], to[1])}.`;
    } else {
      message = `Il faut capturer ! Sautez par-dessus le pion en ${label(cx, cy)} : ${label(from[0], from[1])} → ${label(to[0], to[1])}.`;
    }
  } else if (captures.length > 0) {
    const [cx, cy] = captures[0];
    message = `Bonne occasion : capturez le pion en ${label(cx, cy)} (${label(from[0], from[1])} → ${label(to[0], to[1])}).`;
  } else {
    message = `Déplacez le pion en ${label(from[0], from[1])} vers ${label(to[0], to[1])}.`;
  }

  return { message, suggestFrom: from, suggestTo: to };
}
